module.exports = __webpack_public_path__ + "static/media/2-en.7b9d793f.svg";